/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsVersion,
    ElementsVersionFromJSON,
    ElementsVersionFromJSONTyped,
    ElementsVersionToJSON,
    GlobalAlert,
    GlobalAlertFromJSON,
    GlobalAlertFromJSONTyped,
    GlobalAlertToJSON,
    License,
    LicenseFromJSON,
    LicenseFromJSONTyped,
    LicenseToJSON,
    SAMLProviderMini,
    SAMLProviderMiniFromJSON,
    SAMLProviderMiniFromJSONTyped,
    SAMLProviderMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface SystemInfoEndpointResponse
 */
export interface SystemInfoEndpointResponse {
    /**
     * 
     * @type {License}
     * @memberof SystemInfoEndpointResponse
     */
    license: License;
    /**
     * 
     * @type {number}
     * @memberof SystemInfoEndpointResponse
     */
    clientApiVersion: number;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoEndpointResponse
     */
    ntHostname: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemInfoEndpointResponse
     */
    offersNtpSync: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SystemInfoEndpointResponse
     */
    offersFileSearch: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemInfoEndpointResponse
     */
    language: string;
    /**
     * 
     * @type {Array<SAMLProviderMini>}
     * @memberof SystemInfoEndpointResponse
     */
    readonly samlProviders: Array<SAMLProviderMini>;
    /**
     * 
     * @type {ElementsVersion}
     * @memberof SystemInfoEndpointResponse
     */
    version: ElementsVersion;
    /**
     * 
     * @type {Array<GlobalAlert>}
     * @memberof SystemInfoEndpointResponse
     */
    globalAlerts: Array<GlobalAlert>;
}

export function SystemInfoEndpointResponseFromJSON(json: any): SystemInfoEndpointResponse {
    return SystemInfoEndpointResponseFromJSONTyped(json, false);
}

export function SystemInfoEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemInfoEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'license': LicenseFromJSON(json['license']),
        'clientApiVersion': json['client_api_version'],
        'ntHostname': json['nt_hostname'],
        'offersNtpSync': json['offers_ntp_sync'],
        'offersFileSearch': json['offers_file_search'],
        'language': json['language'],
        'samlProviders': ((json['saml_providers'] as Array<any>).map(SAMLProviderMiniFromJSON)),
        'version': ElementsVersionFromJSON(json['version']),
        'globalAlerts': ((json['global_alerts'] as Array<any>).map(GlobalAlertFromJSON)),
    };
}

export function SystemInfoEndpointResponseToJSON(value?: SystemInfoEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'license': LicenseToJSON(value.license),
        'client_api_version': value.clientApiVersion,
        'nt_hostname': value.ntHostname,
        'offers_ntp_sync': value.offersNtpSync,
        'offers_file_search': value.offersFileSearch,
        'language': value.language,
        'version': ElementsVersionToJSON(value.version),
        'global_alerts': ((value.globalAlerts as Array<any>).map(GlobalAlertToJSON)),
    };
}


